<template>
  <div class="row rowcorrect rowEqual" v-if="checkRoles('configuration', 'ContactDataReportList')">
    <div class="col-lg-12 col-xs-12">
      <b-card>
        <h6 class="card-title mt-0">{{$t('views.reports.contactData.showAll')}}</h6>
        <Loader v-if="loading"></Loader>
        <b-card-body v-else>
          <b-table
            striped hover
            :borderless="true"
            :items="rowsData"
            :fields="columns"
          >
            <template v-slot:cell(firmname1)="data">
              <router-link v-if="data.item.isCompany === 0" :to="{ name: 'ContractorShow', params: { id: '/core/public/index.php/api/user_datas/' + data.item.id }}">
                {{ data.item.name }} {{data.item.surname}}
              </router-link>
              <router-link v-else :to="{ name: 'FirmShow', params: { id: '/core/public/index.php/api/user_datas/' + data.item.id }}">
                <div v-if="data.item.firmname1">{{ data.item.firmname1 }}<br></div>
                <div v-if="data.item.firmname2 && data.item.firmname2 !== data.item.firmname1">{{ data.item.firmname2 }}<br></div>
                {{ $t('views.firm.form.nip') + ': ' + data.item['nip'] }}
              </router-link>
            </template>
            <template v-slot:cell(applicationData)="data">
              <router-link v-for="(item, index) in data.item.applicationData.subdomains" :key="'application' + index" :to="{ name: 'ApplicationShow', params: { id: '/core/public/index.php/api/applications/' + item.id }}">
                <br v-if="index > 0"><span>{{ item.subdomain }}</span>
              </router-link>
              <p class="m-0">{{$t('views.reports.contactData.list.activeAgreements')}}: {{data.item.applicationData.activeAgreements}}</p>
              <p class="m-0">{{$t('views.reports.contactData.list.activeGroupUserdata')}}: {{data.item.applicationData.activeGroupUserdata}}</p>
            </template>
            <template v-slot:cell(lastCorrespondenceMessage)="data">
              <router-link v-if="data.item.lastCorrespondenceMessage" :to="{ name: 'EXCMCorrespondenceThreadShow', params: { id: '/core/public/index.php/api/e_x_c_m_correspondence_threads/' + data.item.lastCorrespondenceMessage.id }}">
                {{ data.item.lastCorrespondenceMessage.lastMessageDateTime }}<br>
                {{ data.item.lastCorrespondenceMessage.subject }}
              </router-link>
            </template>
            <template v-slot:cell(lastCallLog)="data">
              <span v-if="data.item.lastCallLog">
                {{ $moment(data.item.lastCallLog.callDateTime.date).format('YYYY-MM-DD HH:mm:ss') }}
                <span v-if="data.item.lastCallLog.description"><br>{{ data.item.lastCallLog.description }}</span>
              </span>
            </template>
            <template v-slot:cell(lastNote)="data">
              <span v-if="data.item.lastNote">
                {{ $moment(data.item.lastNote.createdAt.date).format('YYYY-MM-DD HH:mm:ss') }}
                <span v-if="data.item.lastNote.title"><br>{{ data.item.lastNote.title }}</span>
                <span v-if="data.item.lastNote.description"><br>{{ data.item.lastNote.description }}</span>
              </span>
            </template>
            <template v-slot:cell(lastRelation)="data">
              <span v-if="data.item.lastRelation">
                {{ $moment(data.item.lastRelation.dateFrom.date).format('YYYY-MM-DD HH:mm:ss') }}
                <span v-if="data.item.lastRelation.title"><br>{{ data.item.lastRelation.title }}</span>
                <span v-if="data.item.lastRelation.description"><br>{{ data.item.lastRelation.description }}</span>
              </span>
            </template>
            <template v-slot:cell(lastRelationPhone)="data">
              <span v-if="data.item.lastRelationPhone">
                {{ $moment(data.item.lastRelationPhone.dateFrom.date).format('YYYY-MM-DD HH:mm:ss') }}
                <span v-if="data.item.lastRelationPhone.title"><br>{{ data.item.lastRelationPhone.title }}</span>
                <span v-if="data.item.lastRelationPhone.description"><br>{{ data.item.lastRelationPhone.description }}</span>
              </span>
            </template>
            <template v-slot:cell(lastInvoices)="data">
              <router-link v-for="(item, index) in data.item.lastInvoices.invoices" :key="'invoice' + index" :to="{ name: 'EXSBInvoiceShow', params: { id: '/core/public/index.php/api/e_x_s_b_invoices/' + item.id }}">
                <br v-if="index > 0"><span>{{ item.number }}</span>
              </router-link>
              <p class="m-0">{{$t('views.reports.contactData.list.sumToPay')}}: {{data.item.lastInvoices.toPay}}</p>
              <p class="m-0">{{$t('views.reports.contactData.list.sumPaid')}}: {{data.item.lastInvoices.paid}}</p>
              <p class="m-0">{{$t('views.reports.contactData.list.sumTotalValueBrutto')}}: {{data.item.lastInvoices.totalValueBrutto}}</p>
            </template>

          </b-table>
          <b-pagination @change="fetchData($event)" v-model="page" :per-page="perPage" :total-rows="counted" class="mt-4 ml-4"></b-pagination>
          <div class="form-group pb-2 col-sm-12">
            <div class="float-right">
              <b-button v-if="downloadXlsStatus === 0" variant="info" @click="downloadXLS()" v-b-tooltip.hover :title="$t('buttons.downloadXLS')" class="float-left ml-2 mr-2 btn-circle">
                <i class="fal fa-file-spreadsheet"></i>
              </b-button>
              <b-button v-if="downloadXlsStatus === 1" variant="success" v-b-tooltip.hover :title="$t('buttons.downloadXLS')" class="float-left ml-2 mr-2 btn-circle">
                <i class="fal fa-spinner fa-spin"></i>
              </b-button>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import { checkPagePermission, checkPermission } from '@/utils/checkRoles'
import ApiService from '@/utils/ApiService'
import Loader from '@/components/Dashboard/Layout/Loader.vue'

export default {
  name: 'contactData',
  components: { Loader },
  data () {
    return {
      loading: true,
      rowsData: [],
      counted: 0,
      page: 1,
      perPage: 10,
      downloadXlsStatus: 0,
      columns: [
        { key: 'firmname1', label: this.$t('views.firm.list.firmname1') },
        { key: 'applicationData', label: this.$t('views.reports.contactData.list.applicationData') },
        { key: 'lastCorrespondenceMessage', label: this.$t('views.reports.contactData.list.lastCorrespondenceMessage') },
        { key: 'lastCallLog', label: this.$t('views.reports.contactData.list.lastCallLog') },
        { key: 'lastNote', label: this.$t('views.reports.contactData.list.lastNote') },
        { key: 'lastRelation', label: this.$t('views.reports.contactData.list.lastRelation') },
        { key: 'lastRelationPhone', label: this.$t('views.reports.contactData.list.lastRelationPhone') },
        { key: 'lastInvoices', label: this.$t('views.reports.contactData.list.lastInvoices') }
      ]
    }
  },
  beforeCreate () {
    checkPagePermission('configuration', 'ContactDataReportList')
  },
  created () {
    this.fetchData()
  },
  destroyed () {
  },
  methods: {
    async downloadXLS () {
      this.downloadXlsStatus = 1
      let params = { xls: 1 }
      await new ApiService('reports/contactreport', params).downloadFile('contactreport_.xls')
      this.downloadXlsStatus = 0
    },
    async fetchData (page = this.page) {
      this.loading = true
      let params = { page: page }
      let response = await new ApiService('reports/contactreport', params).getResults()
      this.rowsData = response.data
      this.counted = response.counted
      this.perPage = response.perPage
      this.page = response.page
      this.loading = false
    },
    checkRoles (type, view = null, component = null) {
      return checkPermission(type, view, component)
    }
  }
}
</script>
